import apiClient from '../lib/apiClient';

// Get all shifts
const getShifts = async (filters = {}) => {
  try {
    const result = await apiClient.get('/shifts', filters);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to fetch shifts' };
  }
};

// Create shift
const createShift = async (data) => {
  try {
    const result = await apiClient.post('/shifts/create', data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to create shift' };
  }
};

// Update shift
const updateShift = async (id, data) => {
  try {
    const result = await apiClient.put(`/shifts/${id}`, data);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to update shift' };
  }
};

// Delete shift
const deleteShift = async (id) => {
  try {
    const result = await apiClient.delete(`/shifts/${id}`);
    return result;
  } catch (error) {
    return { success: false, error: error.message || 'Failed to delete shift' };
  }
};

export default {
  getShifts,
  createShift,
  updateShift,
  deleteShift
};

